import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';

const CreateReward = ({ visible, handleClose, initialData = '', onSubmit, levels }) => {
  const [badgePreview, setBadgePreview] = useState(null);
  const error = useSelector(state => state.Reward.error);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reward_name: initialData?.reward_name || '',
      level_Id: initialData?.level_Id || '',
      badge_image: '',
    },
    validationSchema: Yup.object({
      reward_name: Yup.string().required('Reward name is required'),
      level_Id: Yup.string().required('Level is required'),
      badge_image: initialData ? Yup.mixed() : Yup.mixed().required('Badge image is required'),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append('reward_name', values.reward_name);
      formData.append('level_Id', values.level_Id);
      if (values.badge_image) formData.append('badge_image', values.badge_image);

      if (initialData) {
        onSubmit(initialData._id, formData, onClose);
      } else {
        onSubmit(formData, onClose);
      }
    }
  });

  const onClose = () => {
    formik.resetForm();
    handleClose();
    setBadgePreview(null);
  };

  useEffect(() => {
    if (initialData?.badge_image) {
      setBadgePreview(initialData.badge_image);
    }
  }, [initialData]);

  return (
    <Modal
      title={initialData ? 'Edit Reward' : 'Create Reward'}
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      centered
      width={500}
      maskClosable={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="row g-3">
          <div className="col-12">
            <label className="modal-form">Reward Name <span className="text-danger">*</span></label>
            <input
              type="text"
              name="reward_name"
              className="form-control"
              value={formik.values.reward_name}
              onChange={formik.handleChange}
            />
            {formik.touched.reward_name && formik.errors.reward_name && (
              <span style={{ color: 'red' }}>{formik.errors.reward_name}</span>
            )}
            {error?.reward_name?.[0] && <span style={{ color: 'red' }}>{error?.reward_name?.[0]}</span>}
          </div>

          <div className="col-12">
            <label className="modal-form">Level <span className="text-danger">*</span></label>
            <select
              name="level_Id"
              className="form-control"
              value={formik.values.level_Id}
              onChange={formik.handleChange}
            >
              <option value="">Select Level</option>
              {levels?.map(level => (
                <option key={level._id} value={level._id}>{level.level_name}</option>
              ))}
            </select>
            {formik.touched.level_Id && formik.errors.level_Id && (
              <span style={{ color: 'red' }}>{formik.errors.level_Id}</span>
            )}
            {error?.level_Id?.[0] && <span style={{ color: 'red' }}>{error?.level_Id?.[0]}</span>}
          </div>

          <div className="col-12">
            <label className="modal-form">Badge Image {initialData ? '(leave empty to keep current)' : ''} <span className="text-danger">*</span></label>
            <input
              type="file"
              name="badge_image"
              className="form-control"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue('badge_image', e.currentTarget.files[0]);
                setBadgePreview(URL.createObjectURL(e.currentTarget.files[0]));
              }}
            />
            {formik.touched.badge_image && formik.errors.badge_image && (
              <span style={{ color: 'red' }}>{formik.errors.badge_image}</span>
            )}
            {error?.badge_image?.[0] && <span style={{ color: 'red' }}>{error?.badge_image?.[0]}</span>}
            {badgePreview && <img src={badgePreview} alt="Badge" style={{ width: '100px', marginTop: '10px' }} />}
          </div>
        </div>

        <div className="modal-footer mt-4">
          <button type="button" className="btn btn-light" onClick={onClose}>Close</button>
          <button type="submit" className="btn btn-primary ms-3">
            {initialData ? 'Update' : 'Add'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

CreateReward.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  levels: PropTypes.array.isRequired,
};

export default CreateReward;
